import React from 'react';
import { string, element, node, oneOfType, arrayOf } from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  render() {
    const {
      hasError
    } = this.state;
    return hasError ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : this.props.children;
  }

}

process.env.NODE_ENV !== "production" ? ErrorBoundary.propTypes = {
  fallback: oneOfType([element, string, arrayOf(element), node]),
  children: element
} : void 0;
export default ErrorBoundary;